import {
  EQ_FREQUENCIES,
  PUBLIC_MAX_FREQUENCY,
  PUBLIC_MIN_FREQUENCY,
  filterFrequenciesByRange,
} from './frequencies';

export const PRO_PRICE = '7.99';
export const PRO_PRICE_CURRENCY = 'USD';
export const PRO_PRICE_LABEL = '$7.99/month';

export const PRO_VALUE_PROPOSITION =
  `Full access: all 31 bands, Training mode, Stats, and an editable simulator rig — ${PRO_PRICE_LABEL}.`;

const FREE_BAND_COUNT = filterFrequenciesByRange(
  EQ_FREQUENCIES,
  PUBLIC_MIN_FREQUENCY,
  PUBLIC_MAX_FREQUENCY
).length;

export const PLAN_ROWS = [
  {
    id: 'frequency-range',
    feature: 'Frequency range',
    free: `${FREE_BAND_COUNT} of ${EQ_FREQUENCIES.length} bands · ${PUBLIC_MIN_FREQUENCY} Hz – ${PUBLIC_MAX_FREQUENCY / 1000} kHz`,
    pro: `All ${EQ_FREQUENCIES.length} bands · 20 Hz – 20 kHz`,
  },
  {
    id: 'training-stats',
    feature: 'Training mode & Stats',
    free: 'Practice only — nothing is saved',
    pro: 'Training mode plus progress stats',
  },
  {
    id: 'simulator-rig',
    feature: 'Simulator rig',
    free: 'Fixed demo rig',
    pro: 'Editable rig and advanced simulator controls',
  },
  {
    id: 'price',
    feature: 'Price',
    free: '$0 — no account needed',
    pro: PRO_PRICE_LABEL,
  },
];
